<script>
import { Bar } from "vue-chartjs";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

import IndicadoresAPI from "../../../api/indicadores";

Chart.defaults.global.defaultFontColor = "Black";
Chart.defaults.global.defaultFontFamily = "Roboto";

import { mapGetters } from "vuex";

export default {
  extends: Bar,
  plugins: [ChartDataLabels],

  props: ["filial", "fornecedor", "status", "compradores", "atualizar"],

  data: () => ({
    chartdata: {
      labels: [],
      datasets: [],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              stepSize: 1000000,
              callback: function (value) {
                var ranges = [
                  { divider: 1e6, suffix: "M" },
                  { divider: 1e3, suffix: "k" },
                ];

                function formatNumber(n) {
                  for (var i = 0; i < ranges.length; i++) {
                    if (n >= ranges[i].divider) {
                      return (
                        (n / ranges[i].divider).toString() + ranges[i].suffix
                      );
                    }
                  }
                  return n;
                }

                return formatNumber(value);
              },
            },
          },
        ],
      },
      layout: {
        padding: {
          left: 10,
          right: 10,
          top: 10,
          bottom: 0,
        },
      },
      legend: {
        position: "top",
        labels: {
          fontSize: 11,
          padding: 5,
        },
      },
      title: {
        display: true,
        text: "",
        position: "top",
      },
    },
  }),

  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    }),
  },

  watch: {
    filial() {
      this.buscarDadosGrafico();
    },
    fornecedor() {
      this.buscarDadosGrafico();
    },
    status() {
      this.buscarDadosGrafico();
    },
    atualizar() {
      this.buscarDadosGrafico();
    },
  },

  created() {
    this.buscarDadosGrafico();
  },

  methods: {
    buscarDadosGrafico() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grafico: true,
        grupo: this.grupoCompra,
        filial: this.filial,
        fornecedor: this.fornecedor,
        status: this.status,
        compradores: this.compradores[0] != 0 ? this.compradores : [],
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        IndicadoresAPI.getAnaliseFinanceiro(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.chartdata.labels = [
              "Até 1 mês",
              "De 1 a 2 meses",
              "De 2 a 3 meses",
              "De 3 a 6 meses",
              "De 6 a 9 meses",
              "De 9 a 12 meses",
              "Mais de 12 meses",
              "Sem Comportamento",
              "Itens Novos",
            ];

            this.chartdata.datasets = [];
            this.chartdata.datasets.push({
              label: "Elevado",
              backgroundColor: "#FD0001",
              data: response.data.financeiro.elevado,
              datalabels: {
                anchor: "end",
                align: "end",
                rotation: -70,

                formatter: function (value) {
                  var ranges = [
                    { divider: 1e6, suffix: "M" },
                    { divider: 1e3, suffix: "k" },
                  ];

                  function formatNumber(n) {
                    for (var i = 0; i < ranges.length; i++) {
                      if (n >= ranges[i].divider) {
                        return (
                          (Math.round(n) / ranges[i].divider)
                            .toFixed(1)
                            .toString() + ranges[i].suffix
                        );
                      }
                    }
                    return n;
                  }

                  return formatNumber(value);
                },
              },
            });

            this.chartdata.datasets.push({
              label: "Alto",
              backgroundColor: "#FFBF05",
              data: response.data.financeiro.alto,
              datalabels: {
                anchor: "end",
                align: "end",
                rotation: -70,

                formatter: function (value) {
                  var ranges = [
                    { divider: 1e6, suffix: "M" },
                    { divider: 1e3, suffix: "k" },
                  ];

                  function formatNumber(n) {
                    for (var i = 0; i < ranges.length; i++) {
                      if (n >= ranges[i].divider) {
                        return (
                          (Math.round(n) / ranges[i].divider)
                            .toFixed(1)
                            .toString() + ranges[i].suffix
                        );
                      }
                    }
                    return n;
                  }

                  return formatNumber(value);
                },
              },
            });

            this.chartdata.datasets.push({
              label: "Médio",
              backgroundColor: "#FFFE02",
              data: response.data.financeiro.medio,
              datalabels: {
                anchor: "end",
                align: "end",
                rotation: -70,

                formatter: function (value) {
                  var ranges = [
                    { divider: 1e6, suffix: "M" },
                    { divider: 1e3, suffix: "k" },
                  ];

                  function formatNumber(n) {
                    for (var i = 0; i < ranges.length; i++) {
                      if (n >= ranges[i].divider) {
                        return (
                          (Math.round(n) / ranges[i].divider)
                            .toFixed(1)
                            .toString() + ranges[i].suffix
                        );
                      }
                    }
                    return n;
                  }

                  return formatNumber(value);
                },
              },
            });

            this.chartdata.datasets.push({
              label: "Baixo",
              backgroundColor: "#00AE51",
              data: response.data.financeiro.baixo,
              datalabels: {
                anchor: "end",
                align: "end",
                rotation: -70,

                formatter: function (value) {
                  var ranges = [
                    { divider: 1e6, suffix: "M" },
                    { divider: 1e3, suffix: "k" },
                  ];

                  function formatNumber(n) {
                    for (var i = 0; i < ranges.length; i++) {
                      if (n >= ranges[i].divider) {
                        return (
                          (Math.round(n) / ranges[i].divider)
                            .toFixed(1)
                            .toString() + ranges[i].suffix
                        );
                      }
                    }
                    return n;
                  }

                  return formatNumber(value);
                },
              },
            });

            this.chartdata.datasets.push({
              label: "Ordinário",
              backgroundColor: "#0071C1",
              data: response.data.financeiro.ordinario,
              datalabels: {
                anchor: "end",
                align: "end",
                rotation: -70,

                formatter: function (value) {
                  var ranges = [
                    { divider: 1e6, suffix: "M" },
                    { divider: 1e3, suffix: "k" },
                  ];

                  function formatNumber(n) {
                    for (var i = 0; i < ranges.length; i++) {
                      if (n >= ranges[i].divider) {
                        return (
                          (Math.round(n) / ranges[i].divider)
                            .toFixed(1)
                            .toString() + ranges[i].suffix
                        );
                      }
                    }
                    return n;
                  }

                  return formatNumber(value);
                },
              },
            });

            this.chartdata.datasets.push({
              label: "Sob Encomenda",
              backgroundColor: "#0D0D0D",
              data: response.data.financeiro.encomenda,
              datalabels: {
                anchor: "end",
                align: "end",
                rotation: -70,

                formatter: function (value) {
                  var ranges = [
                    { divider: 1e6, suffix: "M" },
                    { divider: 1e3, suffix: "k" },
                  ];

                  function formatNumber(n) {
                    for (var i = 0; i < ranges.length; i++) {
                      if (n >= ranges[i].divider) {
                        return (
                          (Math.round(n) / ranges[i].divider)
                            .toFixed(1)
                            .toString() + ranges[i].suffix
                        );
                      }
                    }
                    return n;
                  }

                  return formatNumber(value);
                },
              },
            });

            this.renderChart(this.chartdata, this.options);
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false);
            this.Helpers.logout();
          })
      );
    },
  },
};
</script>
